import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, FormArray } from '@angular/forms';
import { EjercicioFiscal } from 'src/app/models/ejercicio-fiscal';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CatalogoService } from 'src/app/services/catalogo.service';

@Component({
  selector: 'edicion-ficha-planeacion',
  templateUrl: './edicion-ficha-planeacion.component.html',
  styleUrls: ['./edicion-ficha-planeacion.component.scss']
})
export class EdicionFichaPlaneacionComponent implements OnInit, OnDestroy {

  public fichaTecnicaForm: FormGroup;
  public keyFichaTecnica: string;
  public dataLoaded: boolean = false;
  public suscripcionFichaTecnica: Subscription;
  public urlIframe: SafeResourceUrl;
  public estadoIframe: string;
  public obraIframe: string;
  public licitacionIframe: string;
  public fechaIframe: string;

  public constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private catalogoService: CatalogoService
  ) { }

  public ngOnInit(): void {
    // this.obtenerFichaTecnica();
  }

  // public obtenerFichaTecnica() {
  //   this.keyFichaTecnica = this.activatedRoute.snapshot.params.keyFichaTecnica;
  //   this.suscripcionFichaTecnica = this.fichaTecnicaService.findByKey(this.keyFichaTecnica).pipe(take(1)).subscribe(
  //     (fichaTecnica: FichaTecnica) => {
  //       this.fichaTecnica = fichaTecnica;
  //       this.estadoIframe = fichaTecnica.estado;
  //       this.obraIframe = fichaTecnica.obra;
  //       this.licitacionIframe = fichaTecnica.licitacion;
  //       this.fechaIframe = fichaTecnica.fecha;
  //       this.inicializarForm();
  //       this.cargarMapa();
  //       this.dataLoaded = true;
  //     },
  //     (error: any) => {
  //       console.error("Error al editar obra", error);
  //     }
  //   );
  // }

  // private inicializarForm(): void {
  //   this.fichaTecnicaForm = this.formBuilder.group({
  //     estado: new FormControl(this.fichaTecnica.estado, [Validators.required]),
  //     obra: new FormControl(this.fichaTecnica.obra, [Validators.required]),
  //     licitacion: new FormControl(this.fichaTecnica.licitacion, [Validators.required]),
  //     fecha: new FormControl(this.fichaTecnica.fecha, [Validators.required]),
  //     nombreObra: new FormControl('Obra en Planeación'),
  //     caracteristicasObra: new FormControl(this.fichaTecnica.caracteristicasObra, [Validators.required]),
  //     tpda: new FormControl(this.fichaTecnica.tpda, [Validators.required]),
  //     tipoCarpeta: new FormControl(this.fichaTecnica.tipoCarpeta, [Validators.required, this.validateId]),
  //     tipoSeccion: new FormControl(this.fichaTecnica.tipoSeccion, [Validators.required, this.validateId]),
  //     periodoEjecucion: new FormControl(this.fichaTecnica.periodoEjecucion, [Validators.required]),
  //     longitudTotal: new FormControl(this.fichaTecnica.longitudTotal, [Validators.required]),
  //     inversionTotal: new FormControl(this.fichaTecnica.inversionTotal, [Validators.required]),
  //     esquemaFinanciamiento: new FormControl(this.fichaTecnica.esquemaFinanciamiento, [Validators.required]),
  //     registroSHCP: new FormControl(this.fichaTecnica.registroSHCP, [Validators.required]),
  //     estatusSHCP: new FormControl(this.fichaTecnica.estatusSHCP, [Validators.required]),
  //     proyectoEjecutivo: new FormControl(this.fichaTecnica.proyectoEjecutivo, [Validators.required]),
  //     liberacionDerecho: new FormControl(this.fichaTecnica.liberacionDerecho, [Validators.required]),
  //     cambioUsoSuelo: new FormControl(this.fichaTecnica.cambioUsoSuelo, [Validators.required]),
  //     manifestacionIA: new FormControl(this.fichaTecnica.manifestacionIA, [Validators.required]),
  //     avanceFisicoGlobal: new FormControl(this.fichaTecnica.avanceFisicoGlobal, [Validators.required]),
  //     avanceFinancieroGlobal: new FormControl(this.fichaTecnica.avanceFinancieroGlobal, [Validators.required]),
  //     observaciones: new FormControl(this.fichaTecnica.observaciones, [Validators.required]),
  //     problematica: new FormControl(this.fichaTecnica.problematica, [Validators.required]),
  //     beneficios: new FormControl(this.fichaTecnica.beneficios, [Validators.required]),
  //     proximasAcciones: new FormControl(this.fichaTecnica.proximasAcciones, [Validators.required]),
  //     incluyeImagenes: new FormControl(true),
  //     ejerciciosFiscales: this.formBuilder.array([]),
  //   });
  //   this.generarArrayEjerciciosFiscales(this.fichaTecnica.ejerciciosFiscales)
  // }

  public validarCheck(checkValue: boolean) {
    if (!checkValue) {
      this.fichaTecnicaForm.get('incluyeImagenes').setValue(0);
    }
  }

  public crearFormEjercicioFiscal(): FormGroup {
    return this.formBuilder.group({
      letrasEsquemaFiscal: new FormControl(''),
      esquemaFiscal: new FormControl(''),
      letrasAsignacion: new FormControl(''),
      asignacion: new FormControl(''),
      letrasMeta: new FormControl(''),
      meta: new FormControl('')
    });
  }

  public generarArrayEjerciciosFiscales(ejerciciosFiscales: EjercicioFiscal[]) {
    ejerciciosFiscales.forEach(ejercicioFiscal => {
      (this.fichaTecnicaForm.get('ejerciciosFiscales') as FormArray).push(this.formArrayEjercicioFiscal(ejercicioFiscal));  
    });
  }

  public formArrayEjercicioFiscal(ejercicioFiscal: EjercicioFiscal): FormGroup {
    return this.formBuilder.group({
      letrasEsquemaFiscal: new FormControl(ejercicioFiscal.letrasEsquemaFiscal),
      esquemaFiscal: new FormControl(ejercicioFiscal.esquemaFiscal),
      letrasAsignacion: new FormControl(ejercicioFiscal.letrasAsignacion),
      asignacion: new FormControl(ejercicioFiscal.asignacion),
      letrasMeta: new FormControl(ejercicioFiscal.letrasMeta),
      meta: new FormControl(ejercicioFiscal.meta)
    });
  }

  public cargarMapa() {
    this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl("https://sctsupervision-1527449638423.firebaseapp.com/Supervision1.0/estado/mapaestadoPlan.html?a="+this.estadoIframe+"&b="+this.obraIframe+"&c="+this.licitacionIframe+"&d="+this.fechaIframe);
  }

  private validateId(control: AbstractControl) {
    return control.value === '-1' ? { error: 'El campo es requerido' } : null;
  }

  public getError(controlName: string): string {
    let error = '';
    const control = this.fichaTecnicaForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  public agregarEjercicioFiscal(): void {
    (this.fichaTecnicaForm.get('ejerciciosFiscales') as FormArray).push(this.crearFormEjercicioFiscal());
  }

  public eliminarEjercicioFiscal(indice: number): void {
    (<FormArray>this.fichaTecnicaForm.controls.ejerciciosFiscales).removeAt(indice);
  }

  public actualizarFichaTecnica() {
    // let fichaTecnicaActualizada: FichaTecnica = this.crearModelo(this.fichaTecnicaForm.value);
    // this.fichaTecnicaService.update(this.keyFichaTecnica, fichaTecnicaActualizada);
    window.alert("Ficha técnica actualizada.");
  }

  // public crearModelo(fichaTecnicaDeForm: any): FichaTecnica {
  //   let fichaTecnica: FichaTecnica = Object.assign({
  //     fechaActualizacion: new Date()
  //   }, fichaTecnicaDeForm as FichaTecnica);
  //   return fichaTecnica;
  // }

  public ngOnDestroy(): void {
    if (this.suscripcionFichaTecnica) {
      this.suscripcionFichaTecnica.unsubscribe();
    }
  }

}